<script>
export let formats = ['webp','svg'] // TODO : Need to add support for this tag
export let src = ''
export let alt = ''
</script>

<picture>
  <source srcset="{src}.webp" type="image/webp">
  <img src="{src}.svg" alt={alt}>
</picture>